module.exports = __webpack_public_path__ + "static/Omgeo-9baa2ea5b27cbe10dbed36c837931945.png";